// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"core-view__mainContainer___1MAR1","skipToMainContent":"core-view__skipToMainContent___3cbU_","app-container":"core-view__app-container___2X47t"};